import '../css/index.scss';

window.addEventListener('load', () => {
    let t = 220
    let w = 60
    let r = 35
    if (device == 'pc') {
        t = $('.header_container').height()
    }
    if (device == 'mobile') {
        var rfont = $(window).width() / 7.2
        w = rfont * 0.4
        t = rfont * 3.8
        r = rfont * 0.2
    }
    let a = new fixedAudio({
        html: {
            pic: public_domain + '/topic/topic_template/customize/YIQiJieFang_2022010_vol/images/music.png',
            activeClassName: "run",
            className: "music",
            animate: false,
            style: {
                top: t,
                right: r,
                init: true,
                width: w,
            }
        },
        audio: {
            src: public_domain + '/topic/topic_template/customize/YIQiJieFang_2022010_vol/media/bg.mp3',
            loop: true,
            autoplay: true,
            volume: 1,
            mute: true
        }
    })
    $('.banner_area').append(`<video src="${public_domain}/topic/topic_template/customize/YIQiJieFang_2022010_vol/media/${device}.mp4" muted loop  autoplay preload webkit-playsinline="playsinline" playsinline="true" x5-video-player-type="h5-page"></video>`)

    a.on('play', () => {
        window.dispatchEvent(new CustomEvent('audio_play', {}))
    })
    if (device === 'mobile') {
        let video = $('.banner_area video')[0]
        function autoplay() {

            let vPromise = video.play();
            vPromise && vPromise.then(() => {
                document.removeEventListener("WeixinJSBridgeReady", autoplay);
                document.removeEventListener('touchstart', autoplay);
                document.removeEventListener('touchmove', autoplay);
                document.removeEventListener('click', autoplay);
            })
        }
        document.addEventListener("WeixinJSBridgeReady", autoplay, false);
        document.addEventListener('touchstart', autoplay, false);
        document.addEventListener('touchmove', autoplay, false);
        document.addEventListener('click', autoplay, false);
        a.audio.once('unlock', autoplay)
    }
})
